var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contenido',{},[_c('portal',{attrs:{"to":"toolbar-secundaria"}},[_c('buscador',{attrs:{"Controlador":_vm.Controlador}})],1),_c('listado',{attrs:{"Controlador":_vm.Controlador}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }